import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";
import { borderRadius } from "../../../utils/styles/styles";
import { Auxiliares } from "../../../types/TabelasAuxiliares/Auxiliares";
import { successColor, errorColor } from "../../../utils/colors";

interface AlertSanLevelStateProps {
  stateValue: Auxiliares | null;
  additionalStyle?: object;
  hasBackground?: boolean;
}

const AlertSanLevelState: FC<AlertSanLevelStateProps> = ({
  stateValue,
  additionalStyle = {},
  hasBackground = true,
}) => {
  const getStateColor = () => {
    switch (stateValue?.code?.toLowerCase()) {
      case "green":
        return successColor;
      case "yellow":
        return "yellow.400";
      case "red":
        return errorColor;
      default:
        return "gray.700";
    }
  };

  return (
    <Box
      fontWeight="bold"
      backgroundColor={hasBackground ? getStateColor() : "transparent"}
      mr="4"
      style={additionalStyle}
      borderRadius={borderRadius}
    >
      <Text
        px="1"
        textTransform="uppercase"
        fontSize="sm"
        color={hasBackground ? "white" : getStateColor()}
      >
        {stateValue?.name}
      </Text>
    </Box>
  );
};

export default AlertSanLevelState;
